// @flow

import { getEndpoint } from './crud-factory'

export async function getOrganisations(): Promise<Organisation[]> {
  const { organisations } = await getEndpoint('/organisations')
  return organisations
}
